import { render, staticRenderFns } from "./CourseLocations.vue?vue&type=template&id=dacde992"
import script from "./CourseLocations.vue?vue&type=script&lang=js"
export * from "./CourseLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports